import React from 'react'
import { AppContainer } from '../AppContainer/AppContainer'
import { AppWithSessionHOC, AppWithSessionProps } from './AppHOC'

export const DrawerApp: React.FC<AppWithSessionProps> = props => {
  const { session, actionModule, environment, widgetContext } = props
  return (
    <AppWithSessionHOC
      session={session}
      environment={environment}
      actionModule={actionModule}
      widgetContext={widgetContext}
    >
      <AppContainer />
    </AppWithSessionHOC>
  )
}
